<template>
  <div class="discovery-create-goods-item">
    <div
      class="img"
      :style="{ backgroundImage: 'url(' + source.goodsInfoImg + ')' }"
    ></div>
    <div class="content">
      <div class="tit van-multi-ellipsis--l2">
        {{ source.goodsInfoName }}
      </div>
      <div class="amount">
        <span class="prefix">¥</span>
        <span class="value">{{ source.actPrice }}</span>
        <span class="reward">省赚¥</span>
        <span class="reward-value">{{ source.saveProfit || 0 }}</span>
      </div>
      <div class="tabber">
        <div class="act">
          {{ source.actName }}
          <Icon name="arrow" class="icon" />
        </div>
        <div class="btn" @click="select">选择商品</div>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from '@/utils/bus'
import { Icon } from 'vant'
export default {
  props: {
    source: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { Icon },
  methods: {
    select() {
      Bus.$emit('selectDiscoveryCreateGoods', this.source)
      this.$router.back()
    },
  },
}
</script>

<style lang="less" scoped>
.discovery-create-goods-item {
  display: flex;
  margin-bottom: 20px;
  padding: 0 24px;
  .img {
    width: 232px;
    height: 232px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }
  .content {
    flex: 1;
    min-width: 0;
    padding-left: 20px;
    .tit {
      font-size: 28px;
      font-weight: 400;
      color: #000000;
      line-height: 40px;
      height: 80px;
    }
    .amount {
      margin-top: 52px;
      display: flex;
      align-items: flex-end;
      .prefix {
        display: block;
        font-size: 24px;
        line-height: 28px;
        font-weight: 800;
        color: #333333;
      }
      .value {
        display: block;
        font-size: 36px;
        line-height: 36px;
        font-weight: 800;
        color: #333333;
      }
      .reward {
        font-size: 20px;
        line-height: 28px;
        color: #e82035;
        font-weight: 600;
        margin-left: 8px;
      }
      .reward-value {
        font-size: 24px;
        font-weight: 600;
        color: #e82035;
        line-height: 28px;
      }
    }
    .tabber {
      display: flex;
      justify-content: space-between;
      padding-top: 12px;
      .act {
        display: flex;
        align-items: center;
        font-size: 20px;
        font-weight: 400;
        color: #000000;
        line-height: 44px;
        .icon {
          font-size: 24px;
          color: #4c4c4c;
          margin-left: 6px;
        }
      }
      .btn {
        font-size: 24px;
        font-weight: 400;
        color: #ffffff;
        line-height: 24px;
        padding: 10px 18px;
        border-radius: 44px;
        background-color: #e82035;
      }
    }
  }
}
</style>